export const isJsonString = <T = Record<string, unknown>>(str: unknown): T | null => {
  if (typeof str !== 'string' || str.trim() === '') return null

  try {
    const result = JSON.parse(str)
    if (typeof result === 'object' && result !== null && !Array.isArray(result)) {
      return result as T
    }
    return null
  } catch {
    return null
  }
}
